<template>
  <div class="flex gap-2 p-3">
    <MediaPreview
      v-for="image in images"
      :key="image.id"
      class="hover:cursor-pointer"
      :item="image"
      size="md"
      @click="previewImage(image)"
    />
    <MediaViewer
      :open="openMediaViewer"
      :url="activeItem?.url"
      :mime_type="activeItem?.mime_type"
      @close="openMediaViewer = false"
      @next="nextImage"
      @previous="previousImage"
      :multiple="images.length > 1"
    />
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import MediaPreview from "@/Tailwind/Components/MediaPreview.vue";
import MediaViewer from "@/Tailwind/Components/MediaViewer.vue";

const props = defineProps({
  images: Array,
});

const activeItem = ref(null);
const openMediaViewer = ref(false);

function previewImage(item) {
  activeItem.value = item;
  openMediaViewer.value = true;
}

const nextImage = () => {
  const index = props.images.findIndex(
    (photo) => photo.id === activeItem.value.id
  );

  if (index === props.images.length - 1) {
    activeItem.value = props.images[0];
  } else {
    activeItem.value = props.images[index + 1];
  }
};

const previousImage = () => {
  const index = props.images.findIndex(
    (photo) => photo.id === activeItem.value.id
  );

  if (index === 0) {
    activeItem.value = props.images[props.images.length - 1];
  } else {
    activeItem.value = props.images[index - 1];
  }
};
</script>
